import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxParent from "../../util/remote/ajaxParent";
;

const DeleteParentContact=(props)=>{

    const [loading, setLoading] = useState(false)

    const handleDelete = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxParent.deleteParentContact(props.tableID);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.g();
            props.h();
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleDelete}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Delete User Contact"
            id="model-del-pt-contact"
            size="md"
            footer={RenderFooter}
        >

        <div className="row">
        <div className="bg-white">
                <div className="alert text-center">
                    <i className="fe fe-alert-circle fs-50 text-warning" style={{fontSize:"50px"}}></i>
                    <h3 className="mt-2 mb-1">Are you sure you want to delete this user's contact?</h3>
                    <p className="mb-3 mb-3 tx-inverse">This contact will no longer appear in the phonebook.</p>
                </div>
            </div>
        </div>
       
        </SystemModal>
    )
}

export default DeleteParentContact
